<form [formGroup]="form">
  <div
    class="flex"
    [ngClass]="{ 'flex-col': layout === 'linear' }"
  >
    <div [ngClass]="[layout === 'linear' ? 'w-full' : 'w-1/3']">
      <div class="flex pb-4">
        <a
          href="#"
          class="w-1/2 text-center border-l border-t border-b border-gray-200 dark:border-dark-border rounded-l-md border-r-none px-4 py-2 text-gray-400 dark:text-dark-muted text-sm font-normal hover:bg-gray-50 dark:hover:bg-dark-hover"
          [ngClass]="advancedInput ? null : 'bg-theme-primary border-theme-primary text-white hover:bg-theme-primary dark:hover:bg-theme-primary'"
          (click)="$event.preventDefault(); activateSearch()"
        >{{ 'common.search' | translate }}</a>
        <a
          class="w-1/2 text-center border border-gray-200 dark:border-dark-border rounded-r-md border-l-none px-4 py-2 text-gray-400 dark:text-dark-muted text-sm font-normal hover:bg-gray-50 dark:hover:bg-dark-hover"
          [ngClass]="advancedInput ? 'bg-theme-primary border-theme-primary text-white hover:bg-theme-primary dark:hover:bg-theme-primary' : null"
          (click)="$event.preventDefault(); activateAdvanced()"
          href="#">{{ 'common.advanced' | translate }}</a>
      </div>
      <div [ngClass]="[layout === 'linear' ? 'w-full' : 'w-1/3']">
        <app-input-group>
          <label appLabel>{{ 'address.addressType' | translate }}</label>
          <select appSelect [collection]="addressTypeList" [(ngModel)]="addressType" [ngModelOptions]="{ standalone: true }" (ngModelChange)="search.clearInput()"></select>
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'address.daraddress' | translate }}</label>
          <app-input-search
            #search
            [config]="searchConfig"
            (result)="addressSelected($event)">
          </app-input-search>
        </app-input-group>

        <div class="h-[1px] bg-gray-200 dark:bg-dark-border mt-6 mb-4"></div>
      </div>
    </div>
    <div [ngClass]="[layout === 'linear' ? 'w-full' : 'w-1/3']">
      <app-input-group>
        <label appLabel>{{ 'address.roadcode' | translate }}</label>
        <input appInput formControlName="streetCode">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'address.streetName' | translate }}</label>
        <input appInput formControlName="streetName">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'address.streetNumber' | translate }}</label>
        <input appInput formControlName="buildingNumber">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'address.floor' | translate }}</label>
        <input appInput formControlName="floorIdentification">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'address.door' | translate }}</label>
        <input appInput formControlName="roomIdentification">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'address.zipCode' | translate }}</label>
        <input appInput formControlName="postalCode">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'address.city' | translate }}</label>
        <input appInput formControlName="cityName">
      </app-input-group>
    </div>

    <div [ngClass]="[layout === 'linear' ? 'w-full' : 'w-1/3']">
      <app-input-group>
        <label appLabel>{{ 'address.postaldistrict' | translate }}</label>
        <input appInput formControlName="subDivisionName">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'address.municipalcode' | translate }}</label>
        <input appInput formControlName="municipalityCode">
      </app-input-group>

      <app-input-group>
        <label appLabel>{{ 'address.countrycode' | translate }}</label>
        <input appInput formControlName="country">
      </app-input-group>

      @if (this.advancedInput) {
        <a class="text-gray-400 underline text-sm font-normal" href="#"
           (click)="$event.preventDefault();sanitizeAddress()">{{ 'address.cleanAddress' | translate }}</a>
      }
    </div>
  </div>
</form>
